/* 
Author:Lamiaa Moustafa
Desc: Reusable Input component 
*/

import React from "react";
import styled from "styled-components";
import {Input} from "../../Styles/styledComponents/Inputs"



export const FormInput = (props) => {
  const {
    name,
    width,
    height,
     type,
    placeholder,
    ref,
    onChange,
    customStyle,
    label,
    // error,
    disabled,
    value,
    autoComplete,
    prefix
  } = props.data;

  return (
    <FormDiv  height={height}>
      <label>{label}</label>
      <Input
      name={name}
       width={width}
       type={type}
        style={{customStyle}}
        // type={passwordShown}
        placeholder={placeholder}
        onChange={onChange}
        ref={ref}
        disabled={disabled}
        value={value}
        autoComplete={autoComplete}
        prefix={prefix}
      />
    </FormDiv>
  );
};


//FormInput div style for Register page
 const FormDiv = styled.div`
  height: ${(props) => (props.height ? "110px" : "90px")};
  width: 100%;
  display: flex;
  justify-content: center;
  align-items:flex-start;
  flex-direction: column;
  z-index: 99;
  label {
    align-self: start;
    margin-left: 22%;
  }
  @media (max-width: 768px) {
    label {
      margin-left: 10%;
    }
  }
  @media (min-width: 1400px) {
    label {
      margin-left: 25%;
    }
  }
`;